/**
 * Контроль сроков годности остатков: что истекает в ближайшие рабочие дни.
 * Рабочие дни — пн–пт, праздничного календаря нет.
 */

/** Сколько рабочих дней вперёд предупреждаем об окончании срока. */
export const EXPIRY_WARNING_WORKING_DAYS = 3;

/** expired — срок уже прошёл; soon — заканчивается не позже крайней даты. */
export type ExpiryStatus = 'expired' | 'soon';

function toIso(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** Сегодня, гггг-мм-дд, по локальному времени. */
export function todayIso(): string {
  return toIso(new Date());
}

/** Дата через `days` рабочих дней после `fromIso`: субботы и воскресенья не считаются. */
export function addWorkingDays(fromIso: string, days: number): string {
  const [yyyy, mm, dd] = fromIso.split('-').map(Number);
  const date = new Date(yyyy, mm - 1, dd);
  let left = days;
  while (left > 0) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) left -= 1;
  }
  return toIso(date);
}

/**
 * Статус партии по сроку годности: просрочено, если срок раньше сегодня;
 * скоро, если не позже крайней даты; иначе null. Пустой срок — null.
 */
export function expiryStatus(
  expiryDate: string,
  today: string,
  deadline: string
): ExpiryStatus | null {
  if (!expiryDate) return null;
  if (expiryDate < today) return 'expired';
  if (expiryDate <= deadline) return 'soon';
  return null;
}
